<div class="stepper w-full h-full flex">
  <nav *ngIf="initialStepper['stepper'] && initialStepper['stepper'].length > 1" class="steps-list h-full w-56">
    <ul class="step-list aside-bg-color flex flex-col justify-center h-full w-56">
      <ng-container *ngFor="let step of initialStepper['stepper']; let i = index">
        @if (!step.hidden) {
          <li
            class="p-4 mb-2 rounded-md text-sm cursor-pointer flex space-x-2.5 items-center"
            [ngClass]="{ selected: step['selected'], 'text-gray-500': disableButtons }"
            (click)="showSelectedStepper(step, i)"
          >
            @if (!step.visited) {
              <span class="rounded-full text-[8px] px-2 py-0 border-2 border-gray-500" [ngClass]="{ 'border-amber-700': stepperFormGroups.invalid }">
                {{ i + 1 }}
              </span>
            } @else {
              <mat-icon><span class="checked">check_circle</span></mat-icon>
            }
            <span>{{ step?.stepperName }}</span>
          </li>
        }
      </ng-container>
    </ul>
  </nav>

  <div class="step-details modal-body relative">
    <header class="header modal-header flex flex-col gap-2 place-content-between">
      <div class="flex justify-between">
        <h3 class="modal-subline py-1" [innerHTML]="initialStepper.stepLabel"></h3>
        <button mat-icon-button class="button-close" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div *ngIf="stepperHeader" class="flex items-baseline justify-between">
        <h2 class="modal-headline">
          {{ stepperHeader }}
        </h2>
      </div>
    </header>

    <div class="step-data-form modal-main">
      <div class="w-full h-full formFields">
        <form class="w-full h-full" action="" [formGroup]="stepperFormGroups" (keydown.enter)="$event.preventDefault()">
          <ng-template ngFor let-formGroupField [ngForOf]="initialStepper['stepper']" let-i="index">
            <ng-template [ngIf]="formGroupField['selected']">
              <div *ngIf="formGroupField['stepperGroupName']" class="sections" [formGroupName]="formGroupField['stepperGroupName']">
                <fieldset class="field-section-group -mx-4">
                  <ng-template ngFor let-formField [ngForOf]="formGroupField['formFields']">
                    <div
                      [ngSwitch]="formField['fieldType']"
                      class="field-control inline-block"
                      [ngClass]="[formField['widthClass'], !formField.visible ? 'hidden' : '']"
                      id="stepper-dialog_{{ formField['formFieldName'] }}"
                    >
                      <div *ngSwitchCase="'text'" class="input-box mx-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                        <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                          <input
                            autocomplete="off"
                            matInput
                            [type]="formField['inputType'] || ''"
                            [name]="formField['formFieldName']"
                            [formControlName]="formField['formFieldName']"
                            [placeholder]="formField['placeholder'] || ''"
                          />
                          <mat-error *ngIf="stepperFormGroups.controls[formGroupField['stepperGroupName']].get(formField['formFieldName'])?.errors?.['required']">
                            {{ formField['fieldLabel'] }}&nbsp;<ng-container i18n>is required</ng-container>
                          </mat-error>
                          <mat-error *ngIf="stepperFormGroups.controls[formGroupField['stepperGroupName']].get(formField['formFieldName'])?.hasError('inValidEmail')">Invalid email</mat-error>
                        </mat-form-field>
                      </div>
                      <div *ngSwitchCase="'email'" class="input-box mx-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                        <sp-user-email-input-autocomplete
                          [formControlName]="formField['formFieldName']"
                          [users]="users"
                          [enableChips]="true"
                          [required]="formField.validators?.required ?? false"
                          [requiredText]="formField['fieldLabel'] + ' ' + requiredText"
                          (selectedUserArray)="userSelected($event)"
                        ></sp-user-email-input-autocomplete>
                      </div>
                      <div *ngSwitchCase="'copyToClipboard'" class="input-box mx-4 mt-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}</span>
                        <sp-copy-to-clipboard [copyText]="formField.value" [copyButtonLabel]="textCopySharedLinkButton" [notificationText]="textCopySharedLinkSuccess"></sp-copy-to-clipboard>
                      </div>
                      <div *ngSwitchCase="'dropdown'" class="mx-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                        <sp-mat-select-search
                          class="w-full"
                          [formControlName]="formField['formFieldName']"
                          [placeholder]="formField['placeholder'] || ''"
                          [config]="{
                            search: formField['dropDownSearch'],
                            inlineImage: formField['inlineImage'],
                            sortDataSource: formField['sortDataSource'],
                            required: stepperFormGroups.controls[formGroupField['stepperGroupName']].get(formField['formFieldName'])?.errors?.['required'],
                            requiredText: formField['fieldLabel'] + ' ' + requiredText,
                          }"
                          [dataSource]="formField['options'] || []"
                          [attrDataTestId]="'stepper-dialog_' + formField['formFieldName']"
                          (selectedChange)="onValueChange($event, formField['formFieldName'], formField, formGroupField)"
                        ></sp-mat-select-search>
                      </div>
                      <div *ngSwitchCase="'textarea'" class="input-box mx-4 mb-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                        <div>
                          <sp-editor id="textareaEditor" class="block" [formControlName]="formField['formFieldName']" [placeholder]="formField['placeholder'] || ''"> </sp-editor>
                          <mat-error class="text-xs pl-3" *ngIf="getFieldValidation(stepperFormGroups.controls[formGroupField['stepperGroupName']].get(formField['formFieldName']))">
                            {{ formField['fieldLabel'] }}&nbsp;<ng-container i18n>is required</ng-container>
                          </mat-error>
                        </div>
                      </div>
                      <div *ngSwitchCase="'multiSelectChip'" class="mx-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                        <sp-mat-select-search
                          class="w-full"
                          [formControlName]="formField['formFieldName']"
                          [dataSource]="formField['options'] || []"
                          [placeholder]="formField['placeholder'] || ''"
                          [config]="{ search: true, multiple: true, enableSecondPartLabel: false }"
                          [showAvatar]="formField['showAvatar']"
                          (selectedChange)="onSelectedChange($event, formField['formFieldName'])"
                          (removeChip)="removeMultiSelectChip($event, formGroupField['stepperGroupName'], formField['formFieldName'])"
                        ></sp-mat-select-search>
                      </div>
                      <div *ngSwitchCase="'treeHierarchy'" class="input-box mx-4">
                        <sp-mat-tree
                          [matTreeDataSource]="stepperFormGroups.controls[formGroupField['stepperGroupName']].get(formField['formFieldName'])?.value"
                          [selectAllCheckboxDefault]="matTreeCheckbox"
                          [required]="isMatTreeSelected"
                          (isListChecked)="changeStatus($event, formGroupField['stepperGroupName'], formField['formFieldName'])"
                          (nodeList)="selectedFormatList($event)"
                        >
                        </sp-mat-tree>
                        <mat-error *ngIf="isMatTreeSelected">{{ formField['fieldLabel'] }}&nbsp;<ng-container i18n>is required</ng-container></mat-error>
                      </div>
                      <div *ngSwitchCase="'checkbox'" class="input-box mx-4">
                        <mat-checkbox
                          class="input-template template-name w-full m-2 mat-form-field-wrapper"
                          (change)="checkboxChanged($event, formGroupField['stepperGroupName'], formField)"
                          [formControlName]="formField['formFieldName']"
                        >
                          {{ formField.fieldLabel }}
                        </mat-checkbox>
                        <div
                          *ngIf="stepperFormGroups.controls[formGroupField['stepperGroupName']]?.get(formField['formFieldName'])?.errors?.['required']"
                          class="block text-[#f44336] ml-3 -mt-5 text-xs"
                        >
                          {{ formField['fieldLabel'] }}&nbsp;<ng-container i18n>is required</ng-container>
                        </div>
                      </div>
                      <div *ngSwitchCase="'date'" class="mx-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                        <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                          <input
                            autocomplete="off"
                            matInput
                            [min]="formField['minDate']"
                            [max]="formField['maxDate']"
                            (input)="onInput($event, formField, i, formGroupField['stepperGroupName'])"
                            [matDatepicker]="picker"
                            [formControlName]="formField['formFieldName']"
                            [placeholder]="formField['placeholder'] || ''"
                          />
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          <mat-error *ngIf="stepperFormGroups.controls[formGroupField['stepperGroupName']].get(formField['formFieldName'])?.errors?.['required']">
                            {{ formField['fieldLabel'] }}&nbsp;<ng-container i18n>is required</ng-container>
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div *ngSwitchCase="'autocomplete'" class="mx-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                        <mat-form-field color="primary" class="input-template template-name w-full" appearance="outline">
                          <input type="text" [placeholder]="formField['placeholder'] || ''" matInput [formControlName]="formField['formFieldName']" [matAutocomplete]="auto" />
                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option *ngFor="let option of formField['options']" [value]="option.id">
                              {{ option.name }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                      <div *ngSwitchCase="'matChipList'" class="mx-4">
                        <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                        <sp-mat-select-search
                          *ngIf="brandingKey === CustomClients.VKB"
                          [formControlName]="formField['formFieldName']"
                          aria-label="Tags"
                          [dataSource]="allTagsListOption || []"
                          [placeholder]="tagPlaceHolderText"
                          [config]="{
                            search: true,
                            multiple: true,
                            tagField: true,
                            enableSecondPartLabel: false,
                            required: getFieldValidation(stepperFormGroups.controls[formGroupField['stepperGroupName']].get(formField['formFieldName'])),
                            requiredText: formField['fieldLabel'] + ' ' + requiredText,
                          }"
                          (optionChanged)="tagOptionChanged($event, formGroupField.stepperGroupName, formField['formFieldName'])"
                          (removeChip)="removeTagOnChange($event, formGroupField.stepperGroupName, formField['formFieldName'])"
                        ></sp-mat-select-search>
                        <sp-chips-grid-row
                          *ngIf="brandingKey !== CustomClients.VKB"
                          [formControlName]="formField['formFieldName']"
                          [dataSource]="tags"
                          [autoCompSource]="autoCompTags"
                          [required]="getFieldValidation(stepperFormGroups.controls[formGroupField['stepperGroupName']].get(formField['formFieldName']))"
                          [requiredText]="formField['fieldLabel'] + ' ' + requiredText"
                          [chipInputTooltip]="textChipInputTooltip"
                          [matTooltip]="!(AnyAsset | can: 'tagging') ? 'User doesn\'t have access rights to create or edit tags' : ''"
                          (removeChip)="removeTag($event, formGroupField['stepperGroupName'], formField['formFieldName'])"
                          (matChipInputToken)="add($event, formGroupField['stepperGroupName'], formField['formFieldName'])"
                        ></sp-chips-grid-row>
                      </div>
                      <div *ngSwitchCase="'uploadFiles'" class="mx-4">
                        <div class="imageSelector px-4 py-2.5 h-auto grid grid-cols-1">
                          <div class="h-full flex flex-col box-border content-center place-items-center items-baseline justify-around">
                            <sp-file-drag-n-drop
                              [multipleFile]="formField['multipleFile'] !== undefined ? formField['multipleFile'] : true"
                              [required]="fileUploadRequired"
                              (uploadedFiles)="selectedFiles($event)"
                              class="w-full p-3 m-auto"
                            >
                            </sp-file-drag-n-drop>
                            <div *ngIf="fileUploadRequired" class="block text-[#f44336] ml-7 -mt-5 text-xs">{{ formField['fieldLabel'] }}&nbsp;<ng-container i18n>is required</ng-container></div>
                          </div>
                        </div>
                        <div class="selected-content px-4 py-2">
                          <sp-file-list
                            *ngIf="files.length"
                            class="w-full p-3 m-auto"
                            [files]="files"
                            [uploadInProgress]="uploadInProgress"
                            [progress]="progress"
                            [currentUploadFileName]="currentUploadFileName"
                            (filesList)="updatedFilesList($event)"
                          >
                          </sp-file-list>
                        </div>
                      </div>
                      <div *ngSwitchCase="'confirmationLabel'" class="m-4">
                        <div class="confirmationBox text-2xl font-bold text-left py-4">
                          {{ formField.fieldLabel }}
                        </div>
                      </div>
                      <div *ngSwitchCase="'formArray'" class="m-4">
                        <div class="w-full" [formArrayName]="formField['formFieldName']">
                          <p class="font-bold" *ngIf="formField['fieldLabel']">
                            <span class="heading">{{ formField['fieldLabel'] }}</span>
                          </p>
                          <div
                            class="w-full flex flex-col lg:flex-row"
                            *ngFor="let formArrayControls of getControls(formField['formFieldName'], formGroupField['stepperGroupName']); let sIndex = index"
                          >
                            <div class="inline-block w-[80%]" [formGroupName]="sIndex">
                              <ng-template ngFor let-formArrayField [ngForOf]="formField['formFieldGroup']">
                                <div [ngSwitch]="formArrayField['fieldType']" class="field-box inline-table" [ngClass]="formArrayField['widthClass']">
                                  <div class="mx-4 ml-0" *ngSwitchCase="'dropdown'">
                                    <span class="field-label" *ngIf="!formArrayField['hideLabel'] && sIndex === 0">
                                      {{ formArrayField['fieldLabel'] }}{{ formArrayField.validators?.required ? '*' : '' }}
                                    </span>
                                    <sp-mat-select-search
                                      class="w-full"
                                      #formArrayMatSelect
                                      [formControlName]="formArrayField['formFieldName']"
                                      [placeholder]="formArrayField['placeholder']!"
                                      [attrName]="'stepName_' + sIndex"
                                      [dataSource]="formArrayField['options'] || []"
                                      [config]="{
                                        search: true,
                                        required: stepperModel.callFrom === 'publishCollection' ? true : false,
                                        requiredText: formArrayField['fieldLabel'] + ' ' + requiredText,
                                      }"
                                      [attrDataTestId]="'stepper-dialog_' + formArrayField['formFieldName']"
                                      (selectedChange)="agencyValueChange($event, formArrayField['formFieldName'], formField, sIndex, formGroupField)"
                                    ></sp-mat-select-search>
                                  </div>
                                  <div *ngSwitchCase="'treeHierarchy'" class="input-box mx-4">
                                    <span class="field-label" *ngIf="!formArrayField['hideLabel'] && sIndex === 0">
                                      {{ formArrayField['fieldLabel'] }}{{ formArrayField.validators?.required ? '*' : '' }}
                                    </span>
                                    <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                                      <mat-select
                                        class=""
                                        attr.name="stepName_{{ sIndex }}"
                                        [formControlName]="formArrayField['formFieldName']"
                                        [compareWith]="compareMatSelect"
                                        [placeholder]="formArrayField['placeholder']!"
                                        (selectionChange)="agencyValueChange($event, formArrayField['formFieldName'], formField, sIndex, formGroupField)"
                                      >
                                        <mat-select-trigger>
                                          {{ agencyName[sIndex] }}
                                        </mat-select-trigger>
                                        <mat-option value="">{{ PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE }}</mat-option>
                                        <sp-mat-tree
                                          [matTreeDataSource]="clientListMapping[sIndex]"
                                          [showSelectAll]="false"
                                          [showExpandCollapse]="false"
                                          [showBorder]="false"
                                          [required]="isMatTreeSelected"
                                          (nodeList)="selectedClientBrand($event, sIndex); setArrayFieldValidation(sIndex, formArrayField['formFieldName'])"
                                        >
                                        </sp-mat-tree>
                                      </mat-select>
                                      <mat-error *ngIf="!isArrayFieldValid(sIndex, formArrayField['formFieldName'])">
                                        {{ formArrayField['fieldLabel'] }}&nbsp;<ng-container i18n>is required</ng-container>
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                            <div class="w-[20%] action-icons flex justify-start gap-4" [ngClass]="sIndex > 0 ? 'items-start' : 'items-center'">
                              <button mat-fab color="accent" (click)="removeRow(sIndex, formGroupField['stepperGroupName'], formField['formFieldName'], formField)">
                                <mat-icon>delete_outline</mat-icon>
                              </button>
                              <button
                                mat-fab
                                color="accent"
                                [disabled]="disableACBButton"
                                (click)="addRow(formGroupField['stepperGroupName'], formField['formFieldName'], formField['formFieldGroup'])"
                              >
                                <mat-icon>add</mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </fieldset>
              </div>

              <footer class="footer modal-footer">
                <div class="button-row">
                  <ng-template ngFor let-action [ngForOf]="formGroupField['actions']">
                    <div class="left-actions float-left inline-block" [ngClass]="action['actionClass']" *ngIf="action?.actionTypePosition === 'left'">
                      <button
                        type="button"
                        mat-flat-button
                        class="w-auto button-primary inline-flex gap-1"
                        [ngClass]="[action?.alignIcon === 'right' ? 'icon-right' : '', action?.icon && 'icon-' + action?.icon]"
                        (click)="nextGoToStep(action)"
                      >
                        <mat-icon matSuffix class="material-icons-outlined !m-0" [ngClass]="{ 'order-last': action?.alignIcon === 'right' }" *ngIf="action?.icon !== ''">
                          {{ action?.icon }}
                        </mat-icon>
                        <span>{{ action?.actionLabel }}</span>
                      </button>
                    </div>
                    <div class="right-actions float-right inline-block ml-16" *ngIf="action?.actionTypePosition === 'right'">
                      <button
                        type="submit"
                        mat-flat-button
                        class="w-auto button-primary inline-flex gap-1"
                        [ngClass]="[action?.alignIcon === 'right' ? 'icon-right' : '', action?.icon && 'icon-' + action?.icon]"
                        (click)="nextGoToStep(action, stepperFormGroups.controls[formGroupField['stepperGroupName']])"
                      >
                        <mat-icon matSuffix class="material-icons-outlined !m-0" [ngClass]="{ 'order-last': action?.alignIcon === 'right' }" *ngIf="action?.icon && action?.icon !== ''">
                          {{ action?.icon }}
                        </mat-icon>
                        <span>{{ action?.actionLabel }}</span>
                      </button>
                    </div>
                  </ng-template>
                  <div class="clearfix"></div>
                </div>
                <div class="button-row mt-2">
                  <div class="left-actions float-right inline-block"><mat-error *ngIf="formControlValidState" i18n>The required fields are missing</mat-error></div>
                </div>
              </footer>
            </ng-template>
          </ng-template>
        </form>
      </div>
    </div>
  </div>
</div>
